import { LoginWidgetLinks } from 'module/authentication/types';
import { ROCKETLANE_EMAILS } from 'constant';
import { useMemo } from 'react';

export const useAuthenticateLinks = (): LoginWidgetLinks => {
  return useMemo(
    () => ({
      forgotPasswordUrl: '/forgot-password',
      loginUrl: '/login',
      postLoginRedirectUri: `${window.location.origin}/implicit/callback`,
      postLogoutRedirectUri: `${window.location.origin}/login`,
      supportEmail: ROCKETLANE_EMAILS.support,
    }),
    [],
  );
};
